import React, { useState, useRef, useEffect } from 'react';
import SignatureCanvas from 'react-signature-canvas';

export default function SignForm({ setValues, values }) {

    const [signatureImage, setSignatureImage] = useState(null);
    const signatureRef = useRef();

    const handleSave = () => {
        const imageDataUrl = signatureRef.current.toDataURL();
        setValues({ ...values, signature : imageDataUrl })
    };

    const handleClear = () => {
        signatureRef.current.clear();
        setValues({ ...values, signature : '' })
    };

    function HandleChange(e) {
        setValues({ ...values, [e.target.name]: e.target.value })
    }


    useEffect(() => {
        const selectElement = document.getElementById('day');
        
        for (let i = 1; i <= 31; i++) {
            const option = document.createElement('option');
            option.value = i;
            option.text = i;
            selectElement.appendChild(option);
        }

    }, [])


    



    return (<div className="row">
        <div className='col' style={{ width: "100%" }}>


            <input type="text" name="businessName" placeholder="Business Name (Optional)" value={values.businessName} onChange={HandleChange} />

            <input type="text" name="name" placeholder="Signer Name" value={values.name} onChange={HandleChange} />

            <input type="text" name="IDNum" placeholder="ID Number/Business Reg" value={values.IDNum} onChange={HandleChange} />

            <input type="email" name='email' placeholder="Email Address" value={values.email} onChange={HandleChange} />


            <input type="text" name='address' placeholder="Business Address" value={values.address} onChange={HandleChange} />


            <select id="title" name="title" value={values.title} onChange={HandleChange}>
                <option value="">Select Title</option>
                <option value="Mr.">Mr.</option>
                <option value="Mrs.">Mrs.</option>
                <option value="Ms.">Ms.</option>
                <option value="Dr.">Dr.</option>
                <option value="Prof.">Prof.</option>
            </select>


            <select id="day" name="day" value={values.day} onChange={HandleChange}>
                <option value="0">Collection Day</option>
            </select>

            <br />
            
            <p style={{ fontSize: "1.2rem", fontWeight: "bold" }}>Please sign in the area below</p>
            <br />
            
            <div><SignatureCanvas
                ref={signatureRef}
                penColor="black"
                canvasProps={{ width: 300, height: 300, className: 'sigCanvas' }}
            />
                <br />
                <button className="btn btn-danger" style={{ marginRight: 25 }} onClick={handleClear}>Clear</button>
                <button className="btn btn-success" onClick={handleSave}>Save</button></div>

        </div>
    </div>

    )
}
